@if(!initialLoadComplete)
{
<ng-content></ng-content>
}
@else {
  @if(ivrCallBackEnabled) {
<span>
  <a (click)="toggleCallOptions($event)">
    <i><svg><use href="#icon-phone"></use></svg></i>
    {{phoneNumberDisplay}}
  </a>
</span>
  }
  @else {
<span>
    <a rel="nofollow" href="tel:{{phoneNumberDialling}}">
      <i><svg><use href="#icon-phone"></use></svg></i>
      {{phoneNumberDisplay}}
    </a>
</span>
  }
}
@if(showCallOptions)
{
<div class="component-container">
  <div class="component-details">
    <fourd-component-header (close)="onCloseCallOptions()"></fourd-component-header>
    <h3>Our <span class="offer_underline">cheapest</span> way to chat</h3>
    @if (member()?.IsLoggedIn) {
    <div>Account balance is <span>{{member()?.AvailableBalance?.AmountFormatted}}</span></div>
    }
    <div class="component-panel">
      <a tabindex="0" (click)="openCallback($event)" class="component-button button-available">We call you - <i><svg><use href="#icon-phone"></use></svg></i> Call Me Back Now</a>
      <span class="smallprint">How do callbacks work</span>
      <div class="help-tooltip-icon">
        <span>
          <span>?</span>
        </span>
        <div class="help-tooltip-tooltip tooltip-above">
          <div>We will call you straight back to save you the hassle of phoning in. The charges for this service are the same as if you call the freephone number.</div>
        </div>
      </div>
      <a href="tel:{{phoneNumberDialling}}" class="component-button button-available" rel="nofollow">You call us - <i><svg><use href="#icon-phone"></use></svg></i> {{phoneNumberDisplay}}</a>
    </div>
  </div>
</div>
}
@if(showCallback)
{
<fourd-callback (close)="closeCallback()" (cancelChange)="onCancelCallback($event)"></fourd-callback>
}
